const roleCheckboxSelector = '.js-toggle-role';
const cookieName = 'OverridenRoles';

export default function initialiseRoleOverride() {
    if(!roleOverrideEnabled()) {
        return;
    }

    const overriddenRoles = getOverriddenRoles();
    setRoleCheckboxStates(overriddenRoles);

    initialiseMenuClose(reloadPage);

    $(roleCheckboxSelector).on('change', function () {
        const selectedRoles = getSelectedRoles();
        setOverriddenRoles(selectedRoles);
    });
}

function roleOverrideEnabled() {
    return $('.role-override-menu').length;
}

function getOverriddenRoles() {
    const cookie = getCookie();
    const overriddenRolesCookie = cookie[cookieName] || '';

    return overriddenRolesCookie.split(',');
}

function getCookie() {
    const cookie = {};

    const cookiePairs = document.cookie.split('; ');
    for (let i in cookiePairs) {
        var keyValue = cookiePairs[i].split('=');
        cookie[keyValue[0]] = keyValue[1];
    }

    return cookie;
}

function setRoleCheckboxStates(overriddenRoles) {
    for (let i in overriddenRoles) {
        const $checkbox = $(`${roleCheckboxSelector}[value="${overriddenRoles[i]}"]`);
        $checkbox.prop('checked', true);
    }
}

function initialiseMenuClose(callback) {
    $('.role-override-menu__toggle').on('change', function () {
        const isCloseEvent = !$(this).prop('checked');
        if (isCloseEvent) {
            callback();
        }
    });
}

function reloadPage() {
    window.location.reload();
}

function getSelectedRoles() {
    const roles = [];
    $(roleCheckboxSelector + ':checked').map(function (_, input) {
        roles.push((input as HTMLFormElement).value);
    });

    return roles;
}

function setOverriddenRoles(roles) {
    setCookie(cookieName, roles.join(','));
}

function setCookie(key, value) {
    document.cookie = `${key}=${value}; path=/`;
}
